// Sửa khung giờ vàng: mỗi khung 1 hàng 2 TimePicker (bước 15 phút) + xoá; thanh 24h xem trước tô vàng.
import { Button, TimePicker } from "antd";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { goldenHoursError, MAX_GOLDEN_SLOTS, slotSegments } from "./xu-golden-hours-validate";

const FMT = "HH:mm";
const parts = (s) => String(s).split("-").map((t) => dayjs(t, FMT));

function DayBar({ slots }) {
    return (
        <div className="mt-3">
            <div className="relative h-4 rounded bg-gray-100 overflow-hidden">
                {slots.flatMap((s, i) => slotSegments(s).map(([a, b]) => (
                    <div key={`${i}-${a}`} className="absolute top-0 h-full bg-amber-400" style={{ left: `${(a / 1440) * 100}%`, width: `${((b - a) / 1440) * 100}%` }} />
                )))}
            </div>
            <div className="flex justify-between text-[10px] text-gray-400 mt-0.5">
                {["0h", "6h", "12h", "18h", "24h"].map((t) => <span key={t}>{t}</span>)}
            </div>
        </div>
    );
}

export default function XuGoldenHoursEditor({ value, onChange }) {
    const slots = value || [];
    const err = goldenHoursError(slots);
    const setPart = (i, idx, v) => {
        if (!v) return;
        const p = parts(slots[i]);
        p[idx] = v;
        onChange(slots.map((x, k) => (k === i ? `${p[0].format(FMT)}-${p[1].format(FMT)}` : x)));
    };
    return (
        <div>
            {slots.map((s, i) => {
                const [a, b] = parts(s);
                return (
                    <div key={i} className="flex items-center gap-2 mb-2">
                        <span className="text-gray-500 w-14">Khung {i + 1}</span>
                        <TimePicker value={a} format={FMT} minuteStep={15} showNow={false} allowClear={false} onChange={(v) => setPart(i, 0, v)} style={{ width: 100 }} />
                        <span>đến</span>
                        <TimePicker value={b} format={FMT} minuteStep={15} showNow={false} allowClear={false} onChange={(v) => setPart(i, 1, v)} style={{ width: 100 }} />
                        {b.isBefore(a) && <span className="text-xs text-blue-500">qua ngày hôm sau</span>}
                        <Button type="text" danger icon={<FontAwesomeIcon icon={faTrash} />} onClick={() => onChange(slots.filter((_, k) => k !== i))} />
                    </div>
                );
            })}
            <Button size="small" icon={<FontAwesomeIcon icon={faPlus} />} disabled={slots.length >= MAX_GOLDEN_SLOTS} onClick={() => onChange([...slots, "12:00-14:00"])}>
                Thêm khung giờ
            </Button>
            <span className="text-xs text-gray-400 ml-2">Tối đa {MAX_GOLDEN_SLOTS} khung, giờ Việt Nam. Khung kết thúc sớm hơn bắt đầu = chạy qua nửa đêm.</span>
            {err && <div className="text-red-500 text-xs mt-1">{err}</div>}
            <DayBar slots={slots} />
        </div>
    );
}
